import { ErrorSection } from 'src/components/ErrorSection';
import { jsx as _jsx } from "react/jsx-runtime";
export var NotFoundErrorPage = function NotFoundErrorPage() {
  return /*#__PURE__*/_jsx(ErrorSection, {
    statusCode: 404
  });
};
export default NotFoundErrorPage;